import { Box,IconButton, Paper, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import useJournalCell from '../../components/tablecells/Journal'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom'
import { HiOutlineCalendarDateRange } from "react-icons/hi2";

export default function Journals() {
  const { darkMode } = useContext(ThemeContext)
  const { t } = useTranslation()
  const columns = useJournalCell()
  const [journalData, setJournalData] = useState([]);
  const navigate = useNavigate()

  useEffect(() => {
    const stored = localStorage.getItem('journalData');
    const parsed = stored ? JSON.parse(stored) : [];
    setJournalData(parsed);
  }, []);
  return (
    <>
      <Box display="flex" flexDirection="column" height="100vh">
        <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
          <Box display="flex" alignItems="center">
            <IconButton  onClick={() => navigate('/quote')}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
            <Typography fontSize={18} fontWeight={600} ml={1}>{t('journals')}</Typography>
          </Box>
        </Box>

        <Paper elevation={0} sx={{ width: "100%", height: "100% ", backgroundColor: darkMode ? "#151924" : "#fff", overflow: 'auto', boxShadow: 'none' }}>
          {journalData.length === 0 ? (<Typography sx={{ textAlign: 'center', m: 2, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>{t('noData')}</Typography>
          ) : (
            journalData.map((item, index) => (
              <Box key={item.id || `${item.time}-${index}`} sx={{ p: 1.5, boxShadow: darkMode ? "0px 0px 2px rgba(255,255,255,0.05)" : "0px 0px 2px rgba(0,0,0,0.1)", }}>
                <Typography sx={{ fontSize: "0.9rem", fontWeight: 500, color: darkMode ? "#fff" : "#000" }}>{columns[1].render(item[columns[1].dataIndex], item)}</Typography>
                <Typography sx={{ fontSize: "0.75rem", color: darkMode ? "#ccc" : "#555" }}> {columns[0].render(item[columns[0].dataIndex], item)}</Typography>

              </Box>
            ))
          )}
        </Paper>
      </Box>
    </>
  )
} 
